import Collapse from '../../../../common/collapse/Collapse';
import { useState } from "react";
import PropTypes from "prop-types";
import DishHeader from "./dishHeader/DishHeader";
import DishInfo from "./dishInfo/DishInfo";

const Dish = ({dish}) => {
    const [expanded, setExpanded] = useState(false);
    const {name} = dish;
    const handleExpand = () => {
        if (!expanded) {
            setExpanded(true);
        }
    }
    const handleClose = () => {
        setExpanded(false);
    }
    return (
        <Collapse
            id="collapsible-dish-info"
            expanded={expanded}
            onClick={handleExpand}
            renderHeader={() => (
                <DishHeader
                    expanded={expanded}
                    name={name}
                />
            )}
            renderContent={() => (
                <DishInfo dish={dish}/>
            )}
            onClose={handleClose}
            closePosition="top"
        />
    );
}

Dish.propTypes = {
    dish: PropTypes.object.isRequired
}

export default Dish;
